export default {

  namespaced: true,

  state: {
    opened: false
  }

}




// WEBPACK FOOTER //
// ./src/store/modules/menu.js